// WhatWeOffer.jsx
import React from "react";
import { FaRegComments, FaUniversity, FaHeadset, FaRegFileAlt } from "react-icons/fa";
import "./WhatWeOffer.css";

const offers = [
  {
    icon: <FaRegComments size={50} />,
    title: "Competitive salary and performance-based incentives",
    gradient: true,
  },
  {
    icon: <FaUniversity size={50} />,
    title: "Professional development and international exposure",
  },
  {
    icon: <FaHeadset size={50} />,
    title: "A collaborative, inclusive work environment",
  },
  {
    icon: <FaRegFileAlt size={50} />,
    title: "Opportunities to impact lives globally",
  },
];

const WhatWeOffer = () => {
  return (
    <div className="what-we-offer">
      <h2 className="heading">What We Offer</h2>
      <p className="text-muted">Personalized guidance, proven results</p>
      <div className="offer-grid">
        {offers.map((offer, index) => (
          <div
            key={index}
            className={`offer-card ${offer.gradient ? "gradient-bg" : ""}`}
          >
            <div className="icon">{offer.icon}</div>
            <p>{offer.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhatWeOffer;
